module.exports = __webpack_public_path__ + "static/media/register_bg_mobile.0f4ec78d.png";